module.exports = __webpack_public_path__ + "img/HP Deathly Hallows Pt 2.18c78321.jpeg";